import { userStore } from '../../stores/userStore/userStore';

export const checkForRequiredPermissions = componentName => {
  if (process.env.REACT_APP_RBA_ENABLED === 'false') {
    // return true if role based access is disabled
    // returning true would mean that the conditions this function checks for are skipped and will always render the component
    const alwaysRenderComponent = true;
    return alwaysRenderComponent;
  }
  // Get permissions directly from userStore
  const grantedPermissions = userStore.getPermissions;
  const requiredPermissions = REQUIRED_PERMISSIONS_FOR[componentName];
  const userHasRequiredPermissions =
    requiredPermissions &&
    requiredPermissions.every(permission => grantedPermissions.includes(permission));
  return userHasRequiredPermissions;
};

export const REQUIRED_PERMISSIONS_FOR = {
  MAPSEARCH: ['mapSearchAccess'],
  BREADCRUMBS: ['breadcrumbAccess'],
  SUPERVISOR: ['supervisorAccess'],
  SUPERVISOR_MOVE_TICKET: ['supervisorMoveTicket'],
  SUPERVISOR_NOTES_AND_PHOTOS: ['supervisorAppendNotesAndPhotos'],
  SUPERVISOR_UPDATE_TICKET: ['supervisorUpdateTicket'],
  SUPERVISOR_REOPEN_TICKET: ['supervisorReopenTicket'],
  SUPERVISOR_RESPOND_TICKET: ['supervisorRespondToTicket'],
  SUPERVISOR_ONCALL: ['onCallNotificationsView'],
  SUPERVISOR_ONCALL_CONTACTS: ['onCallContactsView'],
  SUPERVISOR_ONCALL_CONTACTS_UPDATE: ['onCallContactsUpdate'],
  SUPERVISOR_ONCALL_STANDBY_INSPECTORS: ['onCallStandbyInspectorsView'],
  SUPERVISOR_ONCALL_STANDBY_INSPECTORS_UPDATE: ['onCallStandbyInspectorsUpdate'],
  SUPERVISOR_ONCALL_NOTIFICATIONS_UPDATE: ['onCallNotificationsUpdate'],
  FILTER_SEARCH_CREATE_UPDATE: ['filterSearchCreateUpdate'],
  FOLDER_CREATE_UPDATE: ['folderCreateUpdate'],
  FOLDER_TICKET_PROCESSING_RULES: ['folderTicketProcessingRules'],
  KEYWORDS_CREATE_UPDATE: ['keywordsCreateUpdate'],
  OQ_VIEW: ['oqView'],
  OQ_UPDATE_MANUAL: ['oqUpdateManualEntry'],
};
